

export const urlParams = new URLSearchParams(window.location.search);

export function getUrlParam(name: string) {
    return urlParams.get(name);
}

export function getUrlParams(prefix: string) {
    return [...urlParams.keys()]
        .filter(key => key.startsWith(prefix));
}

export function wsPrefix() {
    return window.location.protocol === "https:" ? "wss" : "ws";
}